import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["addButton", "commentForm", "commentList", "commentContent", "commentErrors"]

  createSuccess(event) {
    const [_data, _status, xhr] = event.detail
    const newComment = document.createElement("div")

    newComment.classList.add("fade-in-left")
    newComment.innerHTML = xhr.response

    this.commentListTarget.prepend(newComment)
    this.toggleForm()

    setTimeout(() => {
      newComment.classList.remove("fade-in-left")
    }, 600)
  }

  onPostError(event) {
    const [_data, _status, xhr] = event.detail
    this.commentErrorsTarget.innerHTML = xhr.response
  }

  toggleForm() {
    this.commentFormTarget.classList.toggle("d-none")
    this.commentContentTarget.value = ""
    this.commentErrorsTarget.innerText = ""

    const addButton = this.addButtonTarget
    addButton.textContent = addButton.textContent == "Add comment" ? "Cancel" : "Add comment"
  }
}
